import { Button } from "antd";
import React, { useState } from "react";
import vCardFunctions from "../redux/services/vCard.services";
import addGoogleWalletImg from "../../src/assets/images/google-wallet-icon.png";

const AddGoogleWalletButton = ({
  vCard = { _id: null },
  secondaryColor,
  backgroundColor,
}) => {
  const { _id } = vCard;
  const [loading, setLoading] = useState(false);

  const onHandleClick = async () => {
    //  implement here
    if (!_id) return;
    setLoading(true);
    const response = await vCardFunctions.getGoogleWallet(_id);
    if (response.data) {
      const { url } = response.data;
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <Button
        shape="round"
        style={{
          height: "2.5rem",
          borderColor: secondaryColor,
          color: secondaryColor,
          backgroundColor: backgroundColor,
          margin: "0.5rem",
          borderWidth: 0,
          boxShadow: "3px 3px 3px 3px #88888a3a",
          minWidth: !vCard.leadEnable ? "20rem" : 0,
        }}
        loading={loading}
        onClick={(e) => onHandleClick(e).finally(() => setLoading(false))}
        icon={
          <img
            src={addGoogleWalletImg}
            alt="Add to Google Wallet"
            style={{
              height: "2rem",
              marginRight: "0.5rem",
            }}
          ></img>
        }
      >
        Add to Google Wallet
      </Button>
    </>
  );
};

export default AddGoogleWalletButton;
